module.exports = __webpack_public_path__ + "img/99.b735118c.png";